<template>
    <fragment>
        <label v-if="$attrs.label.length > 0">{{ displayLabel }}</label>
        <div class="input-group bootstrap-touchspin">
            <InputWrapper :errors="[]" label="" v-bind="$attrs"/>

            <span class="input-group-btn-vertical">
                <button
                    class="btn btn-white bootstrap-touchspin-up adjust-up-round"
                    type="button"
                    @click="roundUp()">
                    <i class="glyphicon glyphicon-chevron-up"></i>
                </button>
                <button
                    class="btn btn-white bootstrap-touchspin-down adjust-down-round"
                    type="button"
                    @click="roundDown">
                    <i class="glyphicon glyphicon-chevron-down"></i>
                </button>
            </span>
        </div>

        <InputErrors :errors="$attrs.errors" :multiple="$attrs.multipleErrors"/>
    </fragment>
</template>

<script>
import InputWrapper from "./InputWrapper";
import {Fragment} from "vue-fragment";
import InputErrors from "./InputErrors";

export default {
    name: "RoundingInputWrapper",
    components: {InputWrapper, Fragment, InputErrors},
    inheritAttrs: false,
    props: {
        threshold: {
            type: Number,
            default: 0,
        },
        rounding: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        displayLabel() {
            const requiredDesignation = this.$attrs.required ? '*' : '';
            return this.$attrs.label + requiredDesignation;
        },
        roundedCount() {
            return this.rounding * 100;
        },
    },
    methods: {
        roundUp() {
            if (this.threshold - this.roundedCount > 0) {
                const parsedValue = this.$options.filters.floatMoney(this.$attrs.value);
                this.$emit('input', parsedValue + 0.01);
            }
        },
        roundDown() {
            if (this.threshold + this.roundedCount > 0) {
                const parsedValue = this.$options.filters.floatMoney(this.$attrs.value);
                this.$emit('input', parsedValue - 0.01);
            }
        },
        resetThreshold() {
            this.counter = 0;
        },
    },
};
</script>
